export default __webpack_public_path__ + "static/media/illustration-lg.3e902f37.svg";